import { PayoutType } from "types";

export const payoutTypes: PayoutType[] = [PayoutType.Payout, PayoutType.AUTO_PAYOUT];
